import { LitElement, html, utils } from '@hh/global.js'
const {
  getCart,
  addToCart,
  updateCart,
  changeCart,
  updateQuantity,
  reRenderShopifySections,
} = utils

class HHHeader extends LitElement {
  static properties = {
    autocompleteIsOpen: {
      type: Boolean,
      default: false,
    },
  }

  constructor() {
    super()

    this.handleBodyClick = this.handleBodyClick.bind(this)
    this.handleHeaderScroll = this.handleHeaderScroll.bind(this)

    this.headerAccountForm = document.querySelector(
      '.js-header-utility-account'
    )

    this.announcementBar = null
    this.stickyOffset = 0
    this.isHeaderSticky = null
    this.navHeightTimeout = null
    this.lastHeaderHeight = null
    this.lastNavDesktopHeight = null
  }

  connectedCallback() {
    super.connectedCallback()
    document.addEventListener('click', (e) => {
      const pathArr = e.composedPath?.() || [];
      const isMobile = pathArr.find(el => el.tagName === 'HH-NAVIGATION-MOBILE');
      if (!isMobile) {
        const link = e.target.closest('a');
        if (!link) return;
        const nav = link.closest(
          '.nav-desktop, nav[aria-label="mobile navigation"]'
        );
        if (!nav) return;
        const menuItem = link.textContent.trim();
        let menuName = menuItem;
        const navContainer = link.closest('.nav-desktop__dropdown');
        if (navContainer) {
          const activeTier1 = navContainer.querySelector(
            '.nav-desktop__tier1-link-item.is-active'
          );

          if (activeTier1) {
            menuName = activeTier1.innerText.trim();
          } else {
            const t1Index = link.getAttribute('data-t1-content-no');

            if (t1Index && t1Index !== '0') {
              const parent = navContainer.querySelector(
                `.nav-desktop__tier1-link-item[data-t1-item-no="${t1Index}"]`
              );

              if (parent) {
                menuName = parent.innerText.trim();
              }
            }
          }
        }
        if(menuName == menuItem){
          const desktopParent = link.closest('.nav-desktop__link');
          if (desktopParent) {
            const header = desktopParent.querySelector('.nav-desktop__link-header');
            if (header) menuName = header.textContent.trim();
          }
        }
        let pageType = 'other';
        const path = window.location.pathname;

        if (path === '/') pageType = 'home';
        else pageType = path.split('/')[1];
        const payload = {
          menu_name: String(menuName),
          menu_item: String(menuItem),
          page_type: String(pageType)
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'menu_click', ...payload });
      }
    });
    document.addEventListener(
      'pointerdown',
      (e) => {
        const pathArr = e.composedPath?.() || [];
        const isMobile = pathArr.find(el => el.tagName === 'HH-NAVIGATION-MOBILE');
        if (!isMobile) return;

        const button = pathArr.find(el => el.tagName === 'BUTTON');
        if (!button) return;
        if (button.closest('.back')) return;
        const parentLi = button.closest('li');
        const hasArrow = parentLi?.querySelector('.arrow');
        if (hasArrow) return;
        const menuItem = button.innerText.trim();
        if (!menuItem || menuItem == "Close Navigation" || menuItem == "Open Navigation") return;
        let menuName = '';

        const menu = isMobile.shadowRoot.querySelector('.menu');
        let backButton = null;

        if (menu.classList.contains('pane3-open')) {
          backButton = isMobile.shadowRoot.querySelector('.pane3 .back button');
        } else if (menu.classList.contains('pane2-open')) {
          backButton = isMobile.shadowRoot.querySelector('.pane2 .back button');
        }

        if (backButton) {
          menuName = backButton.innerText.trim();
        } else { menuName = menuItem }
        let pageType = 'other';
        const path = window.location.pathname;

        if (path === '/') pageType = 'home';
        else pageType = path.split('/')[1];

        const payload = {
          menu_name: String(menuName),
          menu_item: String(menuItem),
          page_type: String(pageType)
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'menu_click', ...payload });
      },
      true
    );

    document.body.addEventListener('click', this.handleBodyClick)
    this.announcementBar = document.querySelector('.js-announcement-bar')

    if (this.announcementBar) {
      this.stickyOffset = this.announcementBar.getBoundingClientRect().height
    }

    document.addEventListener('scroll', this.handleHeaderScroll, {
      passive: true,
    })

    // const announcementBar = document.querySelector('.js-announcement-bar')
    // let stickyOffset = 0

    // if (announcementBar) {
    //   stickyOffset = announcementBar.getBoundingClientRect().height
    // }
    // document.addEventListener('scroll', (e) => {
    //   if (window.scrollY > stickyOffset) {
    //     document.querySelector('body').classList.add('header-sticky')
    //     document
    //       .querySelector('.js-announcement-bar')
    //       ?.classList.add('is-shrink')

    //     this.classList.add('is-shrink')

    //     setTimeout(() => {
    //       this.setNavDesktopHeight()
    //     }, 300)
    //   } else if (window.scrollY === 0) {
    //     document.querySelector('body').classList.remove('header-sticky')
    //     this.classList.remove('is-shrink')
    //     document
    //       .querySelector('.js-announcement-bar')
    //       ?.classList.remove('is-shrink')
    //     setTimeout(() => {
    //       this.setNavDesktopHeight()
    //     }, 300)
    //   }
    // })

    document.addEventListener('algolia.autocomplete.afterInit', () => {
      this.querySelector('.aa-Input').addEventListener('input', (e) =>
        this.handleSearchChange(e)
      )

      const container = this.querySelector('.header-search-custom__container')
      const input = container.querySelector('.aa-Input')

      const label = document.createElement('label')
      label.setAttribute('for', input.getAttribute('id'))
      label.innerHTML = input.getAttribute('placeholder')
      label.classList.add('sr-only')

      input.parentNode.insertBefore(label, input.nextSibling)

      this.addEventListener('focusin', (e) => {
        const savedState = this.autocompleteIsOpen

        if (e.target === input) {
          this.handleSearchChange(e)
          return
        }

        if (container.contains(e.target) && input.value.length > 0) {
          this.autocompleteIsOpen = true
        } else {
          this.autocompleteIsOpen = false
        }

        if (savedState !== this.autocompleteIsOpen) {
          this.toggleDisableHeaderMenu(this.autocompleteIsOpen)
        }
      })
    })

    this.querySelector('.js-header-overlay').addEventListener('click', () =>
      this.toggleDisableHeaderMenu(false)
    )

    window.addEventListener('cart:changed', this.validateGwp.bind(this))

    setTimeout(() => {
      requestAnimationFrame(() => {
        this.setHeaderDimensions()
      })
    }, 100)
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    document.body.removeEventListener('click', this.handleBodyClick)
    document.removeEventListener('scroll', this.handleHeaderScroll)

    if (this.navHeightTimeout) {
      clearTimeout(this.navHeightTimeout)
      this.navHeightTimeout = null
    }

    window.removeEventListener('cart:changed', this.validateGwp)
  }
  handleHeaderScroll() {
    const shouldShrink = window.scrollY > this.stickyOffset
    const shouldReset = window.scrollY === 0

    if (!shouldShrink && !shouldReset) return

    const nextStickyState = shouldShrink

    if (this.isHeaderSticky === nextStickyState) return

    this.isHeaderSticky = nextStickyState

    document.body.classList.toggle('header-sticky', nextStickyState)
    this.announcementBar?.classList.toggle('is-shrink', nextStickyState)
    this.classList.toggle('is-shrink', nextStickyState)

    if (this.navHeightTimeout) {
      clearTimeout(this.navHeightTimeout)
    }

    this.navHeightTimeout = setTimeout(() => {
      requestAnimationFrame(() => {
        this.setNavDesktopHeight()
      })

      this.navHeightTimeout = null
    }, 300)
  }

  handleBodyClick(e) {
    const path = e.composedPath()
    if (
      path.some((node) => {
        return node.matches && node.matches('.js-header-utility-account')
      })
    ) {
      return true
    }

    if (!e.defaultPrevented && this.isOpen()) {
      this.toggle()
    }

    if (e.target.nodeName != 'INPUT') {
      this.toggleDisableHeaderMenu(false)
    }
  }

  isOpen() {
    return !!this.headerAccountForm.classList.contains('is-active')
  }

  toggle() {
    utils.toggle(this.headerAccountForm, ['is-active'])
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-active'])
  }

  toggleHeaderForm(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(this.headerAccountForm, ['is-active'])
  }

  handleSearchChange(e) {
    if (e.target.value.length > 0) {
      if (this.autocompleteIsOpen) return
      this.toggleDisableHeaderMenu(true)
    } else {
      this.toggleDisableHeaderMenu(false)
    }
  }

  toggleDisableHeaderMenu(isOpen) {
    this.autocompleteIsOpen = isOpen
    this.classList.toggle('search-open', this.autocompleteIsOpen)

    const autocompleteContainer = this.querySelector(
      '#js-autocomplete-container'
    )
    autocompleteContainer.hidden = !this.autocompleteIsOpen
    autocompleteContainer.inert = !this.autocompleteIsOpen

    const navList = this.querySelectorAll('nav')
    navList.forEach((nav) => {
      nav.classList.toggle('is-disabled', this.autocompleteIsOpen)
      nav.inert = this.autocompleteIsOpen
    })

    const headerOverlay = this.querySelector('.js-header-overlay')
    headerOverlay.hidden = !this.autocompleteIsOpen
  }

  async validateGwp(event) {
    if (!window.gwp.enabled) return

    const multipleSelectedGwp = sessionStorage
      .getItem('multipleSelectedGWP')
      ?.split(',')

    const hasMultipleGwp = document
      .querySelector('.inline-cart')
      .hasAttribute('has-multiple-gwp')
    const activeMultipleOfferGwp = document
      .querySelector('.inline-cart')
      .getAttribute('active-multiple-offer-gwp')

    const { items, items_subtotal_price: subTotal } = event.detail.cart

    let cart
    const updates = {}
    const discountsByAmounts = window.gwp.discounts.filter(
      (discount) =>
        discount.minimums === 'minimum-purchase-amt' &&
        subTotal >= discount.minPurchaseAmount * 100
    )

    const removedItems = (sessionStorage.getItem('removedGWP') || '')
      .split(',')
      .filter((item) => !!item)
      .map((item) => +item)

    const selectedProducts = (sessionStorage.getItem('selectedGWP') || '')
      .split(':')
      .filter((set) => !!set)
      .map((set) => set.split(',').map((id) => +id))

    let rawItemsToAdd = discountsByAmounts.map((discount) => {
      const itemInCart = items.find(
        (item) => item.properties?._gwp === discount.id
      )
      const selectedProductId = selectedProducts?.find(
        (offer) => offer[0] === discount.id
      )?.[1]
      const productId = selectedProductId || discount.giftId

      return {
        id: productId,
        quantity: discount.giftQuantity,
        properties: {
          _gwp: discount.id,
        },
      }
    })

    let itemsToAdd = discountsByAmounts
      .map((discount) => {
        const itemInCart = items.find(
          (item) => item.properties?._gwp === discount.id
        )
        const selectedProductId = selectedProducts?.find(
          (offer) => offer[0] === discount.id
        )?.[1]
        const productId = selectedProductId || discount.giftId

        return {
          id: productId,
          quantity: discount.giftQuantity,
          properties: {
            _gwp: discount.id,
          },
        }
      })
      .filter((item) => item.quantity > 0)

    let multipleGwpsToAdd = rawItemsToAdd
      .flatMap((item) => {
        const selectedIDs = sessionStorage.getItem('selectedGWP')?.split(',')
        if (Array.isArray(item.id)) {
          // For multiple gwp in offer
          return item.id
            .map((id) => {
              if ((selectedIDs || []).includes(id)) {
                return {
                  id: parseInt(id),
                  quantity: 1,
                  properties: { ...item.properties },
                }
              }
            })
            .filter((item) => item !== undefined)
        }
      })
      .filter((item) => item !== undefined)

    const hasMultipleGwpSelected =
      sessionStorage.getItem('multipleSelectedGWP')?.split(',') || []

    const filteredItemsToAdd = itemsToAdd.filter(
      (item) =>
        !Array.isArray(item.id) && !removedItems.includes(item.properties._gwp)
    )

    const sections = !!document.querySelector('#inline-cart')?.dataset?.id
      ? `inline-cart,header`
      : 'mini-cart,header'

    const gwpItem = event.detail.cart.items.filter(
      (item) => item.properties?._gwp
    )
    const productId = event.detail.productId
    const gwpProductId = filteredItemsToAdd.filter(
      (item) => item.id == productId
    )

    if (gwpProductId.length > 0) {
      if (filteredItemsToAdd.length > 0 && gwpItem.length === 0) {
        if (hasMultipleGwpSelected.length > 0) {
          const multipleGwpToAdd = multipleGwpsToAdd?.filter((gwpId) => {
            return multipleSelectedGwp?.includes(gwpId.id.toString())
          })

          cart = await addToCart({ items: multipleGwpToAdd, sections })
          sessionStorage.removeItem('multipleSelectedGWP')
        } else if (gwpProductId.length) {
          cart = await addToCart({ items: gwpProductId, sections })
        }
      } else if (filteredItemsToAdd.length > 0 && gwpItem.length === 0) {
        cart = await addToCart({ items: gwpProductId, sections })
      } else if (
        filteredItemsToAdd.length > 0 &&
        gwpItem.length !== 0 &&
        !hasMultipleGwp
      ) {
        updates[gwpItem[0].key] = 0
        cart = await updateCart(updates, sections)
        const sessionItems = (sessionStorage.getItem('removedGWP') || '').split(
          ','
        )
        sessionStorage.setItem(
          'removedGWP',
          [...new Set([...sessionItems, gwpItem[0].variant_id])].join(',')
        )
        const productId = event.detail.productId
        const gwpProductId = filteredItemsToAdd.filter(
          (item) => item.id == productId
        )

        cart = await addToCart({ items: gwpProductId, sections })
      } else if (hasMultipleGwp) {
        gwpItem.forEach((gwp) => {
          updates[`${gwp.key}`] = 0
        })

        cart = await updateCart(updates, sections)

        if (hasMultipleGwpSelected.length >= 1) {
          const multipleGwpToAdd = multipleGwpsToAdd?.filter((gwpId) => {
            return multipleSelectedGwp?.includes(gwpId.id.toString())
          })

          cart = await addToCart({ items: multipleGwpToAdd, sections })
          sessionStorage.removeItem('multipleSelectedGWP')
        } else if (gwpProductId.length) {
          cart = await addToCart({ items: gwpProductId, sections })
        }
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart:updatedgwpitems', {
        bubbles: true,
        detail: {
          itemsToAdd,
        },
      })
    )

    if (!!cart) reRenderShopifySections(cart)
  }

  setHeaderDimensions() {
    const root = document.documentElement
    const header = document.querySelector('.js-header-wrapper')
    const navDesktop = document.querySelector('.nav-desktop')

    const headerHeight = header?.getBoundingClientRect().height
    const navDesktopHeight = navDesktop?.getBoundingClientRect().height

    if (headerHeight != null && headerHeight !== this.lastHeaderHeight) {
      this.lastHeaderHeight = headerHeight
      root.style.setProperty('--hh-header-height', `${headerHeight}px`)
    }

    if (
      navDesktopHeight != null &&
      navDesktopHeight !== this.lastNavDesktopHeight
    ) {
      this.lastNavDesktopHeight = navDesktopHeight
      root.style.setProperty('--hh-header-nav-height', `${navDesktopHeight}px`)
    }
  }

  setNavDesktopHeight() {
    const root = document.documentElement
    const navDesktop = document.querySelector('.nav-desktop')

    if (!navDesktop) return

    const navDesktopHeight = navDesktop.getBoundingClientRect().height

    if (navDesktopHeight === this.lastNavDesktopHeight) return

    this.lastNavDesktopHeight = navDesktopHeight

    root.style.setProperty(
      '--hh-header-nav-height',
      `${navDesktopHeight}px`
    )
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
      @toggleHeaderForm="${this.toggleHeaderForm}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)
